import { ApolloClient,HttpLink, InMemoryCache, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
// import { createUploadLink } from "apollo-upload-client";

const cache = new InMemoryCache();

const tokenValue = localStorage.getItem("token") ? localStorage.getItem("token") : " ";

const uploadLink =new HttpLink({
  uri: process.env.REACT_APP_API_URL,
  headers: {
    authorization: `Bearer ${tokenValue}`,
  },
});

const errorHandler = onError(({ graphQLErrors }) => {
  const hasUnauthorized =
    graphQLErrors &&
    graphQLErrors.find((error) => {
      const { message } = error;
      return message.includes("Unauthorized");
    });
  if (hasUnauthorized) {
    localStorage.clear();
    window.location.href = "/";
  }
});

const apolloclient = new ApolloClient({
  link: from([errorHandler, uploadLink]),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "network-only",
    },
  },
});

export default apolloclient;
